/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Progress_Tab_StrengthInputs */

const en_features_progress_tab_strength = /** @type {(inputs: Features_Progress_Tab_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strength`)
};

const pl_features_progress_tab_strength = /** @type {(inputs: Features_Progress_Tab_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siła`)
};

/**
* | output |
* | --- |
* | "Strength" |
*
* @param {Features_Progress_Tab_StrengthInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_progress_tab_strength = /** @type {((inputs?: Features_Progress_Tab_StrengthInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Progress_Tab_StrengthInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_progress_tab_strength(inputs)
	return en_features_progress_tab_strength(inputs)
});